interface ICreateImageUrlOptions {
    width?: number
    height?: number
    resolution?: number
    aspectRatio?: number
    format?: 'auto' | 'png' | 'jpeg' | 'webp'
    quality?: number
}

export const createImageUrl = (path: string, options?: ICreateImageUrlOptions) => {
    const aspectRatio = options?.aspectRatio
    // round to the nearest whole number
    const width = Math.round(options?.width ?? 0)
    const height = Math.round(options?.height ?? (aspectRatio ? width / aspectRatio : 0))

    const resolution = options?.resolution ?? 2
    if (!path) {
        return ''
    }

    try {
        const serverUrl = new URL(path)
        const format = options?.format ?? serverUrl.searchParams.get('format') ?? 'auto'

        serverUrl.searchParams.set('format', format)
        if (width) serverUrl.searchParams.set('width', `${width * resolution}`)
        if (height) serverUrl.searchParams.set('height', `${height * resolution}`)
        if (options?.quality) serverUrl.searchParams.set('quality', `${options.quality}`)

        return serverUrl.toString()
    } catch {
        return path
    }
}
